import { Component } from '@angular/core';

@Component({
    templateUrl: './explore-location-page.component.html'
})
export class ExploreLocationPageComponent {}
